import { Button, Popup } from 'next-common-lib';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Trans } from 'react-i18next';
import * as confirmDeleteActions from 'redux/ducks/common/confirmDeleteDucks';
import i18n from 'i18n';

export const ConfirmDelete = () => {
  const dispatch = useDispatch();
  const confirmDelete = useSelector(state => state.confirmDelete);

  const mappingMessage = () => {
    const result = [];
    confirmDelete.message.forEach(msg => {
      result.push(<Trans i18nKey={i18n.t(msg)} />);
    });
    return result;
  };

  return (
    <>
      {confirmDelete.isShow && (
        <Popup
          id="employee_ConfirmDelete"
          isShow={confirmDelete.isShow}
          isDimed={confirmDelete.isShow}
          dimedClassName=""
          size="xs"
          componentType="normalPopup"
          closeFunction={() => {
            dispatch(confirmDeleteActions.close());
          }}
          headerComponent={[
            <h1 className="popup-title" key={1}>
              {i18n.t('EM_T_NOTICE')}
            </h1>,
          ]}
          contentsComponent={mappingMessage()}
          bottomComponent={[
            <div className="btn-set al-right">
              <div className="btn-group">
                <Button
                  componentType="solid"
                  className="secondary"
                  size="md"
                  label={i18n.t('EM_T_CANCEL')}
                  onClick={() => {
                    dispatch(confirmDeleteActions.close());
                  }}
                />
                <Button
                  componentType="solid"
                  className="warning"
                  size="md"
                  label={i18n.t('EM_T_DELETE')}
                  onClick={() => {
                    confirmDelete.callback();
                    dispatch(confirmDeleteActions.close());
                  }}
                />
              </div>
            </div>,
          ]}
        />
      )}
    </>
  );
};
ConfirmDelete.propTypes = {};
ConfirmDelete.defaultProps = {};
export default ConfirmDelete;
